import promoRestService from '../../services/PromoRestService';
import { setCampaignTypes } from '../../slices/organization/reducer';
export const getCampaignTypes = async (dispatch) => {
  try {
    const response = await promoRestService?.get(`api/v1/campaign-types`);
    if (response?.status === 200) {
      dispatch(setCampaignTypes(response?.data));
    }
    return response?.data || [];
  } catch (error) {
    return [];
  }
};
